import React, {Suspense} from 'react';

import {BrowserRouter, Routes,Route,} from "react-router-dom"
import Homepage from './Pages/Homepage';
import Header from './Components/Header';
import Contactme from './Pages/Contactme';
import Projects from './Pages/Projects';
import Passions from './Pages/Passions';
import "./App.css"

import Footer from './Components/Footer';
import Effect from './Components/effect3d/effect';
import Bio from './Pages/bio/bio';

export default function App() {
  return (
  
    <BrowserRouter >
    <div className='body1'>
    

     
      <div className="main">
        <Header />
        <div className="effect">
          <Suspense fallback={null}>
      <Effect />
    </Suspense>
        </div>
      
        <div className='main-app'>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/Contactme" element={<Contactme />}/>
          <Route path="/Projects" element={<Projects />}/>
          <Route path="/bio" element={<Bio />}/>
         
        </Routes>
        </div>
        
      </div>
      <Footer/>
        </div>
    </BrowserRouter>
  
  );
}

